// Both OIDC providers (iFixit/Oidc/OidcProviderController.php and
// iFixit/Store/Controllers/Oidc/OidcProviderController.php) redirect logged-out
// users to /Login with the authorize URL in last_page, so login must resume it.
const oidcAuthorizePaths = new Set(['/api/2.0/oidc/authorize', '/api/2.0/store/oidc/authorize']);

export function isOidcAuthorizePath(pathname: string): boolean {
   return oidcAuthorizePaths.has(pathname);
}
